import template from './deleted_shipments.html';
import controller from './deleted_shipments.controller';
import './deleted_shipments.scss';

let branchManagementDeletedShipmentsComponent = {
    restrict: "E",
    binding: {},
    template,
    controller
}

export default branchManagementDeletedShipmentsComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/deleted_shipments/deleted_shipments.component.js